/**
 * Created by Holger Szuesz <development@szuesz.de> on 18.07.2018 17:04
 */

import * as React from 'react';
import { Route } from 'react-router-dom';

import Home from "./Home";
import Papers from './Papers';
import Projects from './Projects';
import Readinglist from './Readinglist';

import '../styles/Main.css';

//  <Route path="/:type/:key" render={props => <Stats {...props} with={this.state} />} />

class Main extends React.Component {
    public render() {
        return (
            <main>
                <Route exact={true} path="/" render={props => <Home {...props} with={this.state} />} />
                <Route exact={true} path="/Readinglist" render={props => <Readinglist {...props} with={this.state} />} />
                <Route exact={true} path="/Projects" render={props => <Projects {...props} with={this.state} />} />
                <Route exact={true} path="/Papers" render={props => <Papers {...props} with={this.state} />} />
            </main>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.tsx